/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IInsurancePolicy } from 'app/shared/model/insurance-policy.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IHospitalBill } from 'app/shared/model/hospital-bill.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { InsuranceClaimStatus } from 'app/shared/model/enumerations/insurance-claim-status.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IInsuranceClaim {
  id?: string;
  claimCode?: string | null;
  dateFrom?: number | null;
  dateTo?: number | null;
  adjustment?: string | null;
  claimedTotal?: number | null;
  approvedTotal?: number | null;
  dateProcessed?: number | null;
  explanation?: string | null;
  rejectionReason?: string | null;
  guaranteeId?: string | null;
  externalId?: string | null;
  type?: keyof typeof PatientType | null;
  status?: keyof typeof InsuranceClaimStatus | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  active?: boolean | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  lastUpdated?: dayjs.Dayjs | null;
  cursor?: number;
  policy?: IInsurancePolicy;
  patient?: IGlucoUser | null;
  location?: IHospital | null;
  bill?: IHospitalBill | null;
}

export const defaultValue: Readonly<IInsuranceClaim> = {
  active: false,
};
